import { TooltipPositionCallback } from "echarts/types/dist/shared";

const TOOLTIP_MARGIN = 10;

export const calculateEChartsTooltipPosition: TooltipPositionCallback = (point, params, dom, rect, size) => {
  if (!rect) {
    return "bottom";
  }
  // Position tooltip below the hovered element, centering it horizontally.
  // If it overflows the bottom or sides of the chart, adjust position to keep it visible.
  const { x: elementX, y: elementY, width: elementWidth, height: elementHeight } = rect;
  const [tooltipWidth, tooltipHeight] = size.contentSize;
  const [viewportWidth, viewportHeight] = size.viewSize;

  let tooltipX = elementX + elementWidth / 2 - tooltipWidth / 2;
  let tooltipY = elementY + elementHeight + TOOLTIP_MARGIN;

  if (tooltipX < TOOLTIP_MARGIN) {
    tooltipX = TOOLTIP_MARGIN;
  }
  if (tooltipX + tooltipWidth + TOOLTIP_MARGIN > viewportWidth) {
    tooltipX = viewportWidth - tooltipWidth - TOOLTIP_MARGIN;
  }

  const wouldOverflowBottom = tooltipY + tooltipHeight + TOOLTIP_MARGIN > viewportHeight;
  if (wouldOverflowBottom) {
    tooltipY = elementY - tooltipHeight - TOOLTIP_MARGIN;
    if (tooltipY < TOOLTIP_MARGIN) {
      tooltipY = TOOLTIP_MARGIN;
    }
  }

  return [tooltipX, tooltipY];
};
